
@if(!isLoading()){
    <div id="page" class="f-col">
        <h4 class="font-bold reward-title">
            <span class="bigger" style="transform: scale(-1, 1);">
                🎉
            </span>
            <span class="reward-title f-wrap">
                <span>
                    {{title()}}
                </span>
                @if(giver()?.image_url; as image_url){
                    <img class="giver-image"[src]="image_url | bucket" alt="{{giver()?.name}}" [title]="giver()?.name" />
                }
            </span>
            <span class="bigger">
                🎉
            </span>
        </h4>
    
        @for(gift of gifts(); track gift._id){
            <div>
                <div class="gift" [style.background-image]="gift.background_url ? 'url('+ (gift.background_url|bucket) + ')' : null">
                    <div class="f-row content">
                        <div class="f-col f-main-center">
                            <img [src]="((gift.logo_url || gift.brand?.logo_url) | bucket) || '/brands/no-logo.png'" alt="Gift Preview"/>
                        </div>
                        <div class="f-col content-details f-main-center">
                            <div>
                                <h2 class="font-semibold gift-title">{{gift.title}}</h2>
                                @if(gift.brand){
                                    <p class="brand-name">{{gift.brand.name}}</p>
                                }
                            </div>
                            <p class="gift-type font-bold">{{gift.type.toUpperCase()}}</p>
                        </div>
                    </div>
                </div>
                @if(gift.end){
                    <p class="expiration">Valid to claim until {{gift.end | date: 'MMMM d, y'}}</p>
                }
            </div>
        }
    
    
        <a id="claimButton" (click)="claimGift()" mat-flat-button class="cta">
            <span class="btn-tl font-extrabold">CLAIM</span>
        </a>
    </div>
} @else {
    <div class="svg-loader">
        <object data="old/cloudigo_loader.svg" type="image/svg+xml"></object>
    </div>
}